import { Directive, Input, ElementRef, OnChanges, OnDestroy } from '@angular/core';
import { IHRBMicroUiConfig } from '../interfaces/hrblock-micro-ui-config-interface';
import { HRBMicroUIAppManager } from '../app-manager/hrblock-micro-ui-app-manager';
import { DataService } from '../services/data.service';

/** Micro App loader Directive */
@Directive({
    selector: '[hrblockMicroAppLoader]'
})
export class HRBMicroAppLoaderDirective implements OnChanges, OnDestroy {

    /** hrblockOcap MicroApp Loader input data */
    @Input() public hrblockMicroAppLoader: IHRBMicroUiConfig;

    /**
     * constructor function
     */
    constructor(
        private elementRef: ElementRef,
        private dataService: DataService
    ) { };

    /**
     * ngOnChanges
     */
    public ngOnChanges(): void {
        if (this.hrblockMicroAppLoader) {
            this.loadMicroApp(this.hrblockMicroAppLoader)
        }
        //Go top when loading a new page
        document.body.scrollTop = document.body.scrollTop !==  0 && 0; // For Safari
        document.documentElement.scrollTop = document.documentElement.scrollTop !==  0 && 0; // For Chrome, Firefox, IE and Opera

    };

    public ngOnDestroy(): void {
        if (this.hrblockMicroAppLoader) {
            //this.destroy(this.hrblockMicroAppLoader)
        }
    }

    /**
     * OnInit lifecycle method
     */
    protected init(): void { }

    /**
     * OnDestroy life cycle method, called when component is destroyed
     */
    protected destroy(config: IHRBMicroUiConfig): void {
        const appManager = new HRBMicroUIAppManager(config, this.dataService);
        appManager.delete(this.elementRef);
    }

    /**
     * method to load micro App
     * @param name micro app name
     * @param path micro app path
     */
    private loadMicroApp(config: IHRBMicroUiConfig) {
        const appManager = new HRBMicroUIAppManager(config, this.dataService);
        appManager.load(this.elementRef);
    };
}
